import axios from 'axios'
import $console from '@zuto/utilities/src/$console'
import { getExperimentOverride } from './experiment-overrides'

type GetIsExperimentType = (
  key: string,
  experimentName?: string
) => Promise<boolean>

export interface ExperimentServiceReturn {
  getIsExperiment: GetIsExperimentType
}

interface ExperimentAPIResponse {
  experimentName: string,
  key: string,
  isInExperiment: boolean
}

const ExperimentService = (
  experimentsApi?: string
): ExperimentServiceReturn => {
  const getIsExperiment: GetIsExperimentType = async (
    key,
    experimentName
  ): Promise<boolean> => {
    if (!experimentName) return false
    // Check for test overrides set via POST /api/app-form/experiments before calling the real service.
    // getExperimentOverride returns undefined when no override exists, so this safely falls through.
    //if (process.env.TEST_ENV === 'playwright') {
      console.log(`ExperimentService: Checking for override for experiment ${experimentName} with key ${key}`)
      const override = getExperimentOverride(experimentName)
      if (override !== undefined) return override
    //}

    const client = axios.create({
      baseURL: experimentsApi || process.env.EXPERIMENT_SERVICE_URL,
      headers: { 'Z-Auth-Key': process.env.EXPERIMENT_SERVICE_KEY }
    })

    try {
      const { data } = await client.get<ExperimentAPIResponse>(
        `v2/experiments/${experimentName}/outcomes/${key}`
      )
      return data.isInExperiment
    } catch (e) {
      if (!axios.isAxiosError(e) || e?.response?.status !== 404) {
        $console.error(
          `ExperimentService Error - ${e}. { URL: ${process.env.EXPERIMENT_SERVICE_URL}, Auth-Key: ${process.env.EXPERIMENT_SERVICE_KEY} }`
        )
      }
      return false
    }
  }

  return {
    getIsExperiment
  }
}

export default ExperimentService
